import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Utility } from 'src/app/core/common';
import { DocumentCriteria } from 'src/app/common';

@Component({
  selector: 'app-manage-documents',
  templateUrl: './manage-documents.component.html',
  styleUrls: ['./manage-documents.component.scss']
})
export class ManageDocumentsComponent implements OnInit {
  constructor(private documentService: DocumentService, private spinner: SpinnerService) { }
  Utility = Utility;

  documents: any[];
  total: number;
  criteria = new DocumentCriteria();
  selected: any = {};
  limit = 10;

  @ViewChild('documentModal') documentModal: NgxSmartModalComponent;
  changeFile: string;
  file: File;

  async ngOnInit() {
    await this.load();
  }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show();
    const result = await this.documentService.getList(this.criteria, page.from, page.limit);
    this.documents = result.documents;
    this.total = result.total;
    this.spinner.hide();
  }

  openModal(document?: any) {
    this.selected = Object.assign({}, document || {
      IsSaleable: true,
      IsDownloadable: true
    });
    this.changeFile = this.selected.File ? 'old' : 'none';
    this.documentModal.open();
  }

  async delete(id: string) {
    this.spinner.show('action');
    await this.documentService.delete(id);
    this.spinner.hide('action');
    await this.load();
  }

  async save() {
    this.spinner.show('action');
    if (this.changeFile == 'none') { delete this.selected.File; }
    await this.documentService.save(this.selected, this.changeFile == 'new' ? this.file : null);
    this.spinner.hide('action');
    this.documentModal.close();
    await this.load();
  }

  async download(id: string) {
    const file = await this.documentService.download(id, true);
    // var blob = new Blob([file.Content], { type: file.ContentType });
    const link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + file.Content;
    link.download = file.Name;
    link.click();
  }
}
